export const VARIANT = {
	ERROR: 'error',
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
} as const;

export type Variant = typeof VARIANT[keyof typeof VARIANT];

export interface BannerProps {
	text?: string;
	variant?: Variant;
}
